import { Flex } from '@dnb/eufemia';
import { Form, Value, Wizard } from '@dnb/eufemia/extensions/forms';
import { ApiDto } from '@portals/shared/portal/ApiDto';
import { AppApiEntitlementRequestSchemaV2Form } from '@portals/shared/portal/AppApiEntitlementDto';
import { useMemo } from 'react';

import ScopeCard from '../../application/components/ScopeCard';
type SummaryProps = {
  api: ApiDto;
  formId: string;
  showAdditionalInfo?: boolean;
};
export default function Summary({ api, formId, showAdditionalInfo }: SummaryProps) {
  const { getValue } = Form.useData<AppApiEntitlementRequestSchemaV2Form>(formId);

  const selectedScopes = useMemo(() => {
    const scopes: AppApiEntitlementRequestSchemaV2Form['scopes'] = getValue('/scopes');
    if (!scopes) return [];
    return scopes.filter((scope) => scope.test || scope.live);
  }, [getValue]);
  return (
    <Form.Card bottom="large">
      <Value.SummaryList>
        <Value.String label={api.name} value={api.description || ''} />
      </Value.SummaryList>
      <Value.SummaryList>
        {/* eslint-disable-next-line @typescript-eslint/no-explicit-any*/}
        {selectedScopes.map((scope: any) => {
          const environments = [];
          if (scope.test) environments.push('Test');
          if (scope.live) environments.push('Live');
          return (
            <ScopeCard
              environments={environments}
              key={scope.name}
              scopeDescription={scope.description}
              scopeId={scope.id}
              scopeName={scope.name}
            />
          );
        })}
      </Value.SummaryList>

      {showAdditionalInfo && (
        <Value.SummaryList>
          <Value.String label="Subscriber type" path="/serviceNowMetaData/subscriberType" />
          <Value.String label="Subscriber sub type" path="/serviceNowMetaData/subscriberSubType" />
          <Value.Boolean
            label="Only persons with specific roles"
            path="/serviceNowMetaData/onlyPersonsWithSpecificRoles"
          />
          <Value.Boolean
            label="Data will be encrypted on field level"
            path="/serviceNowMetaData/dataWillBeEncryptedOnFieldLevel"
          />
          <Value.Boolean
            label="Data will be encrypted on table level"
            path="/serviceNowMetaData/dataWillBeEncryptedOnTableLevel"
          />
          <Value.Boolean
            label="Data will be encrypted in transit"
            path="/serviceNowMetaData/dataWillBeEncryptedInTransit"
          />
          <Value.String label="Purpose" path="/serviceNowMetaData/purpose" />
          {getValue('/useCase') && <Value.String label="Use case" path="/useCase" />}
        </Value.SummaryList>
      )}
      <Flex.Container>
        <Wizard.Buttons />
        <Form.SubmitButton icon_position="left" variant="send">
          Submit Request
        </Form.SubmitButton>
      </Flex.Container>
    </Form.Card>
  );
}
